export const APP_PODCAST = {
  name: "Northwind AI Podcast",
  nameShort: "Podcast",
  slug: "northwind-ai-podcast",
  //
  title: "Join The Conversation",
  titleLong: "Join The Conversation | Northwind AI Podcast",
  tagline: "Join the conversation",
  keywords: ["northwind", "northwind ai", "northwind ai podcast", "ai podcast"],
  description:
    "Promote ideas, MVPs and startups. Discuss uses of AI & ML in your field. Join our Guest Panel for a brief Design Session, Fireside Chat, and Case Study episode.",
  summary:
    "Promote Ideas, MVPs & Startups. Discuss Uses of AI & ML in Your Field",
  summaryRichText:
    "Promote Ideas, MVPs & Startups. <br/>Discuss Uses of AI & ML in Your Field",
  tags: ["Design Session", "Fireside Chat", "Case Study"],
  startData: "2026-05-22T11:00:00.000",
  launchData: "2026-05-27T11:00:00.000",
  //
  domain: "podcast.northwindai.org",
  website: "https://podcast.northwindai.org",
  socialPreview: "https://northwindai.org/social-preview-podcast.png",
  unsubscribeUrl: "https://northwindai.org/podcast",
};
